<template>
  <el-dialog
    class="b-dialog"
    v-bind="$attrs"
    v-on="$listeners"
    :close-on-click-modal="$attrs.closeOnClickModal || false"
    :close-on-press-escape="$attrs.closeOnPressEscape || false"
  >
    <slot></slot>
    <div slot="footer" class="dialog-footer"><slot name="footer"></slot></div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AdbDialog',
};
</script>

<style lang="scss" scoped>
.b-dialog {
  overflow: auto;
  ::v-deep .el-dialog {
    border-radius: 4px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__body {
    overflow: auto;
    padding: 0;
    color: $shipber-text-color-black;
  }

  ::v-deep .el-dialog__header {
    background: $shipber-dialog-color-header;
    text-align: left;
    font-weight: 400;

    .el-dialog__title {
      color: $shipber-text-color-black;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 16px;
  }

  ::v-deep .el-dialog__footer {
    padding: 8px 24px 11px 24px;
    border-top: 1px solid #eaedf0;
    .left {
      float: left;
      color: $shipber-text-color-black;
      border: 1px solid #c6cdd5;
      padding: 9px 20px;
    }
  }
}
</style>
